import Vue from 'vue'
import VueI18n from 'vue-i18n'
import inViewportDirective from 'vue-in-viewport-directive'
import * as VueGoogleMaps from 'vue2-google-maps'

import App from '@/App.vue'
import router from '@/router'
import store from '@/store/'
import i18n from '@/locale'
import '@/register-sw'

import InViewport from '@/components/InViewport'
import GridContainer from '@/components/grid/GridContainer'
import GridRow from '@/components/grid/GridRow'
import PageView from '@/components/PageView'

Vue.config.productionTip = false

Vue.use(VueI18n)
Vue.directive('in-viewport', inViewportDirective)

Vue.component('InViewport', InViewport)
Vue.component('GridContainer', GridContainer)
Vue.component('GridRow', GridRow)
Vue.component('PageView', PageView)

Vue.use(VueGoogleMaps, { load: { key: process.env.VUE_APP_MAP_KEY } })

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js